import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/tenant-premium.css";
import "./styles/tenant-layouts.css";
import { consumeSiteSignIn } from "./lib/siteSignIn";

// Debug helper: track full page reloads (useful for diagnosing "white screen looping").
try {
  const sp = new URLSearchParams(window.location.search);
  if (sp.get("debug") === "1") {
    const key = "__app_reload_count";
    const next = (Number(sessionStorage.getItem(key) ?? "0") || 0) + 1;
    sessionStorage.setItem(key, String(next));
    sessionStorage.setItem("__app_reload_last_at", new Date().toISOString());
  }
} catch {
  // ignore
}

// Owner arriving from "View Website" in the admin: sign them in on this site.
void consumeSiteSignIn();

createRoot(document.getElementById("root")!).render(<App />);
